import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import "./LoginStyle.css"

interface Props{
    setLoggedState: React.Dispatch<React.SetStateAction<number>>;
    setLoggedName: React.Dispatch<React.SetStateAction<String>>;
    setLoggedID: React.Dispatch<React.SetStateAction<String>>;
    setAGBStatus: React.Dispatch<React.SetStateAction<number>>;
    setDSGVOStatus: React.Dispatch<React.SetStateAction<number>>;
    setUseCondStatus: React.Dispatch<React.SetStateAction<number>>;
}

const Login = ({setLoggedState,setLoggedName,setLoggedID,setAGBStatus,setDSGVOStatus,setUseCondStatus}:Props) => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [passwordVisible, setPasswordVisible] = useState(false);
    
    const navigate = useNavigate();

    const onSignInClick = () => {
      navigate("/SignIn")
    }

    const onForgetPasswordClick = () => {
      navigate("/ForgetPassword")
    }

     const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
    };
        
    const onButtonClick = () => {
        // Set initial error values to empty
        setEmailError("")
        setPasswordError("")

        // Check if the user has entered both fields correctly
        if ("" === email) {
            setEmailError("Please enter your username")
            return
        }

        if ("" === password) {
            setPasswordError("Please enter a password")
            return
        }

        if (password.length < 7) {
            setPasswordError("The password must be 8 characters or longer")
            return
        }

        handleLogin(email, password);
    }

    const handleLogin = async (login:string, password: string) => {
        try {
            setLoggedState(0);
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/LoginHandler.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              login,
              password,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            console.log('Erfolgreich eingeloggt:', data);
            setLoggedState(1);
            setLoggedName(data['rescueName'])
            setLoggedID(data['ID'])
            setAGBStatus(parseInt(data['agbStatus']))
            setDSGVOStatus(parseInt(data['dsgvoStatus']))
            setUseCondStatus(parseInt(data['useCondStatus']))
            navigate("/MainPage")
          } else {
            const data = await response.json();
            console.log(data);
            console.error('Fehler beim Einloggen:', response.statusText);
            setPasswordError("Falscher Benutzername oder Passwort")
          }
        } catch (error) {
          console.error('Fehler beim Einloggen:', error);
          setPasswordError("Falscher Benutzername oder Passwort")
        }
      };

    return <div className="LoginStyle_mainContainer">
    <div className="LoginStyle_titleContainer">
        <h2>RescueOfficer Login</h2>
    </div>
    <br />
    <div className="LoginStyle_inputContainer">
        <input
            value={email}
            placeholder="Benutzernamen eingeben"
            onChange={ev => setEmail(ev.target.value)}
            className="LoginStyle_inputBox" />
        <label className="LoginStyle_errorLabel">{emailError}</label>
    </div>
    <br />

    <div className="LoginStyle_inputContainer">
      <div className="LoginStyle_passwordContainer">
        <input
          className="LoginStyle_inputBox"
          placeholder="Passwort eingeben"
          type={passwordVisible ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <FontAwesomeIcon
          icon={passwordVisible ? faEyeSlash : faEye}
          onClick={togglePasswordVisibility}
          className="LoginStyle_passwordIcon"
        />
      </div>
      <label className="LoginStyle_errorLabel">{passwordError}</label>
    </div>
    <br />
    <div className="LoginStyle_inputContainer">
        <input
            className="LoginStyle_inputButton"
            type="button"
            onClick={onButtonClick}
            value="Anmelden" />
    </div>

    <div>
      <input
        className="LoginStyle_forgotPasswordButton"
        type="button"
        onClick={onForgetPasswordClick}
        value="Passwort vergessen" />
    </div>

    <br />
    <div>
      <input
        className="LoginStyle_forgotPasswordButton"
        type="button"
        onClick={onSignInClick}
        value="Registrieren" />
    </div>

</div>
}

export default Login
